module.exports = "/_next/static/images/LinkedProfiles@2x-fac28debd9df119295d5fec825a553a5.webp";